module.exports = __webpack_public_path__ + "static/media/rakesh.0848a023.jpeg";